var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "searchResult" }, [
    _c("table", { staticClass: "table table-sm table-hover table-striped" }, [
      _c("thead", [
        _c(
          "tr",
          [
            _c("th", { staticClass: "max-w-110" }),
            _vm._v(" "),
            _c("th"),
            _vm._v(" "),
            _c("th"),
            _vm._v(" "),
            _vm._l(_vm.projects, function (project) {
              return project.id && project.is_active
                ? _c("th", [_vm._v(_vm._s(project.name))])
                : _vm._e()
            }),
            _vm._v(" "),
            _vm._l(_vm.extraFields, function (field) {
              return _c("th", [_vm._v(_vm._s(_vm.fieldsNames[field]))])
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.records, function (record, index) {
          return _c(
            "tr",
            { key: index },
            [
              _c("td", { staticClass: "max-w-110" }, [
                _c("p", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: `http://rancond.info/index.php/ostatki-na-skladakh?prep=${record.id}&store=`,
                        target: "_blank",
                      },
                    },
                    [_vm._v(_vm._s(record.prep))]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-muted" }, [
                    _vm._v("(" + _vm._s(record.id) + ")"),
                  ]),
                ]),
                _vm._v(" "),
                record.egk || record.dop_egk
                  ? _c("p", { staticClass: "text-muted" }, [
                      _vm._v(
                        "ЕГК: " +
                          _vm._s(record.egk) +
                          " " +
                          _vm._s(record.dop_egk)
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("p", { staticClass: "cost_price_text" }, [
                  _c("span", {
                    class: ["priority", "priority-" + record.priority],
                  }),
                  _vm._v(" валюта:\n          " + _vm._s(record.currency)),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "cost_price_text" }, [
                  _vm._v(
                    "страна: " +
                      _vm._s(
                        _vm.$AllCountries[
                          record.country
                        ].full_country.toUpperCase()
                      )
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "cost_price_text" },
                  [
                    _vm.getFilterValue("c3")
                      ? [
                          _c("i", { staticClass: "icon-fa icon-fa-rub" }),
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                Math.round(
                                  (record.pk_cost_price /
                                    _vm.$AllCurrencies[33].rate) *
                                    10
                                ) / 10
                              ) +
                              " RUB\n          "
                          ),
                        ]
                      : [
                          _c("i", { staticClass: "icon-fa icon-fa-eur" }),
                          _vm._v(
                            " " +
                              _vm._s(record.pk_cost_price) +
                              " EUR\n          "
                          ),
                        ],
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(_vm.printData(record, "expireDates")),
                  },
                }),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(_vm.printData(record, "gosRegistration")),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n        " + _vm._s(_vm.printProfit(record)) + "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("td"),
              _vm._v(" "),
              _vm._l(_vm.projects, function (project) {
                return project.id && project.is_active
                  ? _c("td", { staticClass: "projects_td" }, [
                      _vm.getActivityRecords(record.prices, project.id) &&
                      _vm.savedData[record.id] &&
                      Object.keys(_vm.savedData[record.id])
                        ? _c("div", [
                            _c("div", { staticClass: "form-group" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.savedData[record.id][project.id]
                                        .active,
                                    expression:
                                      "savedData[record.id][project.id].active",
                                  },
                                ],
                                attrs: {
                                  type: "checkbox",
                                  id: `ch_a_${record.id}_${project.id}`,
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.savedData[record.id][project.id].active
                                  )
                                    ? _vm._i(
                                        _vm.savedData[record.id][project.id]
                                          .active,
                                        null
                                      ) > -1
                                    : _vm.savedData[record.id][project.id]
                                        .active,
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$a =
                                          _vm.savedData[record.id][project.id]
                                            .active,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.savedData[record.id][
                                                project.id
                                              ],
                                              "active",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.savedData[record.id][
                                                project.id
                                              ],
                                              "active",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.savedData[record.id][project.id],
                                          "active",
                                          $$c
                                        )
                                      }
                                    },
                                    function ($event) {
                                      return _vm.updateDataToSave(
                                        record,
                                        "active",
                                        project.id
                                      )
                                    },
                                  ],
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  attrs: {
                                    for: `ch_a_${record.id}_${project.id}`,
                                  },
                                },
                                [_vm._v("Активность")]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: `http://rancond.info/index.php/nomenklatura/sinkhronizatsiya?editdrug=1&sid=${project.id}&morion=${record.id}`,
                                  target: "_blank",
                                },
                              },
                              [_vm._v("Редактировать")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.savedData[record.id][project.id]
                                        .order,
                                    expression:
                                      "savedData[record.id][project.id].order",
                                  },
                                ],
                                attrs: {
                                  type: "checkbox",
                                  id: `ch_o_${record.id}_${project.id}`,
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.savedData[record.id][project.id].order
                                  )
                                    ? _vm._i(
                                        _vm.savedData[record.id][project.id]
                                          .order,
                                        null
                                      ) > -1
                                    : _vm.savedData[record.id][project.id]
                                        .order,
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$a =
                                          _vm.savedData[record.id][project.id]
                                            .order,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.savedData[record.id][
                                                project.id
                                              ],
                                              "order",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.savedData[record.id][
                                                project.id
                                              ],
                                              "order",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.savedData[record.id][project.id],
                                          "order",
                                          $$c
                                        )
                                      }
                                    },
                                    function ($event) {
                                      return _vm.updateDataToSave(
                                        record,
                                        "order",
                                        project.id
                                      )
                                    },
                                  ],
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  attrs: {
                                    for: `ch_o_${record.id}_${project.id}`,
                                  },
                                },
                                [_vm._v("Заказ")]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              _vm._l(
                                _vm.getActivityRecords(
                                  record.prices,
                                  project.id,
                                  true
                                ),
                                function (price) {
                                  return _c(
                                    "div",
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group mb-1" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "input-group-prepend",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "input-group-text",
                                                },
                                                [_vm._v(_vm._s(price.qty))]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.savedData[record.id][
                                                    project.id
                                                  ].prices[price.qty],
                                                expression:
                                                  "savedData[record.id][project.id].prices[price.qty]",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: { type: "text" },
                                            domProps: {
                                              value:
                                                _vm.savedData[record.id][
                                                  project.id
                                                ].prices[price.qty],
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.updateDataToSave(
                                                  record,
                                                  "prices",
                                                  project.id
                                                )
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.savedData[record.id][
                                                    project.id
                                                  ].prices,
                                                  price.qty,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.getFilterValue("c11")
                                        ? [
                                            _c(
                                              "p",
                                              { staticClass: "profitPercent" },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.printOverPrice(
                                                        record.pk_cost_price,
                                                        _vm.savedData[
                                                          record.id
                                                        ][project.id].prices[
                                                          price.qty
                                                        ]
                                                      )
                                                    ) +
                                                    "%"
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  )
                                }
                              ),
                              0
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm._l(_vm.extraFields, function (field) {
                return _c(
                  "td",
                  [
                    field === "saleStat"
                      ? [
                          _vm._l(_vm.monthIndex, function (mNameInd, mInd) {
                            return _c("p", [
                              _vm._v(
                                _vm._s(_vm.monthsNames[+mNameInd].short) +
                                  ":\n            " +
                                  _vm._s(
                                    (_vm.extraData[field][record.id] &&
                                      _vm.extraData[field][record.id][mInd]) ||
                                      0
                                  )
                              ),
                            ])
                          }),
                          _vm._v(" "),
                          _vm.extraData.profitGrow
                            ? [
                                _c("p", {
                                  staticClass: "profit_grow",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.printSaleGrow(
                                        _vm.extraData.profitGrow[record.id]
                                      )
                                    ),
                                  },
                                }),
                              ]
                            : _vm._e(),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    field === "incomePrices"
                      ? _vm._l(
                          _vm.extraData[field][record.id],
                          function (income) {
                            return _c("p", [
                              _vm._v(
                                _vm._s(Math.round(income.price * 10) / 10) +
                                  "\n            " +
                                  _vm._s(
                                    _vm.$AllCurrencies[income.currency_id]
                                      .currency
                                  )
                              ),
                            ])
                          }
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    field === "orderStat"
                      ? _vm._l(
                          _vm.extraData[field][record.id],
                          function (orders, oInd) {
                            return _c("p", [
                              _vm._v(_vm._s(oInd) + ": " + _vm._s(orders)),
                            ])
                          }
                        )
                      : _vm._e(),
                  ],
                  2
                )
              }),
            ],
            2
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }